import {Types2D} from "@dp-instant/interfaces";
import {RootView} from "@dp-instant/2d";
import {Action} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {Container, Matrix, RenderTexture, Sprite, Texture} from "pixi.js-legacy";

export type ScreenShotActionSIOPayload = {
    image?: Container;
    imageScale?: number;
};

@injectable()
export class ScreenShotActionSIO extends Action<ScreenShotActionSIOPayload> {
    @inject(Types2D.rootView)
    protected root: RootView;

    async execute({image, imageScale = 0.5}: ScreenShotActionSIOPayload): Promise<string> {
        const renderer = this.root.app.renderer;
        image ||= this.root.app.stage;
        const texture = RenderTexture.create({
            width: image.width * imageScale,
            height: image.height * imageScale
        });
        renderer.render(image, texture, false, new Matrix(imageScale, 0, 0, imageScale));
        const sprite = new Sprite(texture);
        const base64string = renderer.extract.base64(sprite, "image/webp");
        Texture.removeFromCache(texture);
        return base64string;
    }
}
